import { computed, defineComponent, inject, ref } from 'vue';

import { IPersonalityType } from "@/interfaces/state.interface";
import { IStore } from "@/interfaces/state.interface";

import { PersonalityTestTracker } from "@/classes/tracker";

export default defineComponent({
	setup: () => {
		const store = inject('store') as IStore;
		const mobileAccordionsOpened = ref([false, false, false, false, false, false]);
		const personalityTypes = computed((): IPersonalityType[] => {
			return store.getters.personalityTypes();
		});

		const togglePersonalityDetailsVisibility = (index: number, trait: string): void => {
			if (index < 0 || index >= mobileAccordionsOpened.value.length) {
				return;
			}

			const action = mobileAccordionsOpened.value[index] ? 'Hide' : 'Show';
			PersonalityTestTracker.fireTracking(`personality_${action}`, trait, index.toString());

			mobileAccordionsOpened.value[index] = !mobileAccordionsOpened.value[index];
		};

		return { mobileAccordionsOpened, personalityTypes, togglePersonalityDetailsVisibility };
	}
});
